import React, { useState } from "react";
import toast from "react-hot-toast";
import { commonServices } from "../../../../api/services/commonServices";
import {
  setCalendarData,
  setDashboardCalendarLoader,
} from "../../../../infra/aggregates/dashboardCalendarSlice";

import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import DTODashboardCalendarData from "./DTODashboardCalendarData";
import DashboardCalendarPresenterData from "./DashboardCalendarPresenterData";
import { useTranslation } from "react-i18next";

const DashboardCalendarDataController = () => {
  
  const { t } = useTranslation();
  const [leaveCalendar, setLeaveCalendar] = useState([]);

  const selector = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  const getDashboardCalendarData = (dashboard_calendar_data) => {
    setLeaveCalendar(dashboard_calendar_data);
  };

  const callbackSubmit = (month, year) => {
    dispatch(setDashboardCalendarLoader(true));

    const _currentMonth = month + 1;
    commonServices
      .getCalendarData(
        selector.authSlice.company_id,
        selector.authSlice.emp_id,
        _currentMonth,
        year
      )
      .then((response) => {
        if (
          response?.data?.leaves?.length > 0 ||
          response?.data?.absents?.length > 0 ||
          response?.data?.holidays?.length > 0 ||
          response?.data?.weekOffs?.length > 0
        ) {
          dispatch(setCalendarData(response?.data));
          setLeaveCalendar(response?.data);
          dispatch(setDashboardCalendarLoader(false));
        } else {
          dispatch(setDashboardCalendarLoader(false));
          toast.error(t("No more Data!"));
        }
      })
      .catch((err) => {
        dispatch(setDashboardCalendarLoader(false));
        console.log(err);
      });
  };

  return (
    <>
      <DTODashboardCalendarData
        setAllDashboardCalendarData={getDashboardCalendarData}
      />
      <DashboardCalendarPresenterData
        leaveData={leaveCalendar}
        handleCalendarChange={callbackSubmit}
      />
    </>
  );
};

export default DashboardCalendarDataController;
